import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

//redux
import {
  kasaGetSell as onGetData,
  kasaResetAll as onResetData,
  getBranches as onBranches,
  getBanks as onBanks,
  getPersons as onPersons,
  get_K_CAT as onK_CAT,
  kasaResetError as onResetError,
  kasaSellDelete as onDelete,
  kasaGetDailyCash as onDailyCash,
  companiesResetAll as onCompaniesResetAll,
} from "store/actions"
import { currencyFormat } from "helpers/functions"
import { isEmpty } from "lodash"
import DatePicker, {registerLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import Swal from "sweetalert2"
//import "./../../../components/Common/custom.scss"
//import "./../custom.scss"
import axios from "axios"
import authHeader from "helpers/jwt-token-access/auth-token-header"
import zipcelx from "zipcelx"
import Loading2 from "components/Common/Loading2"
import tr from 'date-fns/locale/tr' 
registerLocale("tr", tr)

const ReportsCost1 = props => {
  //meta title
  document.title = "Maliyet Raporu"
  const dispatch = useDispatch()
  const [branchId, setBranchId] = useState(
    localStorage.getItem("branch")
      ? parseInt(localStorage.getItem("branch"))
      : undefined
  )

  const [loading2, setLoading2] = useState(false)
  const [date, setDate] = useState(moment().format("DD-MM-YYYY"))
  const [data, setData] = useState([])
  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange
  const [zero, setZero] = useState(false)

  const [_body, setBody] = useState({
    id: null,
    branchId: props.branchId,
    sku: "",
    product_definition: "",
    name: "",
    serial_number: "",
    description: "",
    vat: 18,
    barcode: "",
    agreementNumber: "",
    date: props.date,
    k_cat: null,
    k_cat_sub: null,
    k_cat_sub_alt: null,
    person: null,
    Price: {
      cost: null,
      cash: null,
      agreementPrice: null,
      card: null,
      bank: null,
      installment: null,
      installmentRate: null,
      bankNet: null,
      card2: null,
      bank2: null,
      installment2: null,
      installmentRate2: null,
      bankNet2: null,
      card3: null,
      bank3: null,
      installment3: null,
      installmentRate3: null,
      bankNet3: null,
      net: null,
      gain: null,
      wallet: null,
      price: null,
    },
    Customer: {
      name: "",
      phone: "",
    },
  })

  const changeInputMultiple = objs => {
    let b = { ..._body }
    for (let obj of objs) {
      if (obj.key.includes(".")) {
        let arr = obj.key.split(".")
        if (arr.length == 2) {
          b[arr[0]][arr[1]] = obj.value
        } else if (arr.length == 3) {
          b[arr[0]][arr[1]][arr[2]] = obj.value
        }
      } else {
        b[obj.key] = obj.value
      }
    }
    setBody(b)
  }

  const {
    error,
    branches,
    reports,
    persons,
    loading,
    k_cat,
    k_cat_sub,
    k_cat_sub_alt,
  } = useSelector(state => ({
    error: state.Dashboard.error,
    branches: state.Companies.branches,
    reports: state.Dashboard.reports,
    persons: state.Companies.persons,
    loading: state.Dashboard.loading,
    k_cat: state.Companies.k_cat,
    k_cat_sub: state.Companies.k_cat_sub,
    k_cat_sub_alt: state.Companies.k_cat_sub_alt,
  }))

  useEffect(() => {
    dispatch(onCompaniesResetAll())
    dispatch(onResetData())
  }, [history])

  useEffect(() => {
    if (isEmpty(branches)) {
      dispatch(onBranches())
    } else if (!isEmpty(branches) && branchId == undefined) {
      setBranchId(branches[0].id)
      localStorage.setItem("branch", branches[0].id)
    } else if (!isEmpty(branchId)) {
      localStorage.setItem("branch", branchId)
    }

    if (isEmpty(persons)) {
      dispatch(onPersons())
    }
    if (isEmpty(k_cat)) {
      dispatch(onK_CAT())
    }
  }, [branches, branchId, error])

  useEffect(() => {
    if (!isEmpty(error)) {
      Swal.fire("Hata", error?.error || JSON.stringify(error), "error").then(
        result => {
          if (result.isConfirmed) {
            dispatch(onResetError())
          }
        }
      )
    }
  }, [branchId, error])

  const handle = async () => {
    setLoading2(true)
    //let startDate = moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url:
        process.env.REACT_APP_BASE_API +
        `/api/products/maliyet/get/${date}?platform_id=62a6259cab8b7c2a7ca7ce67&depo=${branchId}&stok=${
          zero ? 0 : 1
        }`,
      headers: {
        Authorization: authHeader().Authorization,
      },
    }

    await axios
      .request(config)
      .then(response => {
        
        setLoading2(false)
        if (response.data.status == true) {
          setData({ list: response.data.data })
        } else {
          setData([])
        }
      })
      .catch(error => {
        setLoading2(false)
        console.log(error)
        Swal.fire(
          props.t("Error"),
          error?.error ||
            error?.message ||
            error?.error?.message ||
            JSON.stringify(error),
          "error"
        )
        setData([])
      })
  }

  const addDay = count => {
    let isVal = moment(date, "DD-MM-YYYY").add(count, "days").toDate()
    setDate(moment(isVal).format("DD-MM-YYYY"))
    //handle(moment(isVal).format("DD-MM-YYYY"), branchId)
  }

  const exportExcel = () => {
    console.log(branches, branchId)
    const config = {
      filename: `Maliyet Raporu ${
        branches.find(x => x.id == branchId)?.name
      } ${date}`,
      sheet: {
        data: [],
      },
    }
    const dataSet = config.sheet.data
    dataSet.push([
      { value: "Barkod", type: "string" },
      { value: "Seri No", type: "string" },

      { value: "SKU", type: "string" },
      { value: "Ürün", type: "string" },
      { value: "Maliyet", type: "string" },

      { value: "Fiyat", type: "string" },
      { value: "Adet", type: "string" },
      { value: "Marka", type: "string" },
      { value: "Model", type: "string" },
      { value: "Ana Grup", type: "string" },
      { value: "Alt Grup", type: "string" },
    ])

    if (!isEmpty(data.list)) {
      for (let item of data.list) {
        dataSet.push([
          { value: item.barcode || "", type: "string" },
          { value: item.serial_number || "", type: "string" },
          { value: item.sku || "", type: "string" },
          { value: item.name || "", type: "string" },
          { value: item.cost || "", type: "number" },
          { value: item.price || "", type: "number" },
          { value: item.count || "", type: "number" },
          { value: item.brand || "", type: "string" },
          { value: item.model || "", type: "string" },
          { value: item.group || "", type: "string" },
          { value: item.alt_group || "", type: "string" },
        ])
      }
    }

    zipcelx(config)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Reports")}
            breadcrumbItem={props.t("Daily Gain Reports")}
          />
          <Loading2 status={loading2} />
          <Row className="mb-3">
            <Col md={2} xs={12} sm={6}>
              {branches && branches?.length > 1 && branchId != undefined ? (
                <select
                  className="form-select me-xxl-2 my-3 my-xxl-0 d-inline-block"
                  value={branchId}
                  onChange={e => {
                    setBranchId(e.target.value)
                  }}
                >
                  {branches.map((val, idx) => (
                    <option key={idx} value={val.id}>
                      {val.name}
                    </option>
                  ))}
                </select>
              ) : null}
            </Col>
            <Col md={2}>
              <div className="aok-datepicker d-flex">
                <div className="search-box aok-datepicker me-xxl-2 my-3 my-xxl-0 d-inline-block border-radius-2">
                  <div className="position-relative">
                    <label htmlFor="search-bar-0" className="search-label">
                      <span id="search-bar-0-label" className="sr-only">
                        Arama İşlemi
                      </span>
                      {/* <DatePicker
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        onChange={update => {
                          setDateRange(update)
                        }}
                        className="form-control custom-picker"
                        isClearable={true}
                        placeholderText={`GG.AA.YYYY - GG.AA.YYYY`}
                        dateFormat="dd.MM.yyyy"
                      /> */}
                      <DatePicker
                        onChange={value => {
                          setDate(moment(value).format("DD-MM-YYYY"))
                          handle(moment(value).format("DD-MM-YYYY"), branchId)
                        }}
                        id="search-bar-1"
                        className="form-control custom-picker"
                        placeholderText={`GG.AA.YYYY - GG.AA.YYYY`}
                        selected={moment(date, "DD-MM-YYYY").toDate()}
                        dateFormat="dd-MM-yyyy"
                        style={{ borderRadius: "2px", paddingLeft: "10px" }}
                        locale={"tr"}
                      />
                    </label>
                    <i className="bx bx-calendar-alt search-icon"></i>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={1}>
              <div>
                <Button
                  color="primary"
                  type="button"
                  onClick={async () => {
                    console.log(branchId)
                    console.log(_body)
                    if (isEmpty(date)) {
                      Swal.fire(
                        props.t("Error"),
                        "Tarih Seçmek Zorunlu",
                        "error"
                      )
                    } else {
                      await handle()
                    }
                  }}
                >
                  {props.t("Get Reports")}
                </Button>
              </div>
            </Col>
            <Col md={2}>
              <div className="form-check mt-2">
                <Input
                  name="zero"
                  placeholder={"Stokta Olmayanlar"}
                  type="checkbox"
                  className="form-control ms-2"
                  id="zero"
                  onChange={e => setZero(e.target.checked)}
                  value={zero}
                />
                <label className="form-check-label ms-2" htmlFor="zero">
                  Stokta Olmayanlar
                </label>
              </div>
            </Col>
          </Row>
          <Row></Row>
          {!isEmpty(data?.list) ? (
            <Card className="mt-2 mb-2">
              <CardBody>
                <div className="alert alert-info">
                  {props.t("Daily Gain Reports")}
                  <Button
                    className="ms-4"
                    type="button"
                    color="success"
                    onClick={() => {
                      exportExcel()
                    }}
                  >
                    <i className="mdi mdi-microsoft-excel"></i>{" "}
                    {props.t("Export")}
                  </Button>
                </div>
                <div className="table-responsive">
                  <table className="react-table table table-bordered">
                    <thead>
                      <tr>
                        <th>Barkod</th>
                        <th>Seri No</th>
                        <th>SKU</th>
                        <th>Ürün</th>
                        <th>Maliyet</th>
                        <th>Fiyat</th>
                        <th>Adet</th>
                        <th>Marka</th>
                        <th>Model</th>
                        <th>Ana Grup</th>
                        <th>Alt Grup</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.list?.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.barcode}</td>
                          <td>{item.serial_number}</td>
                          <td>{item.sku}</td>
                          <td>{item.name}</td>
                          <td className="align-right">
                            {currencyFormat(item.cost)}
                          </td>
                          <td className="align-right">
                            {currencyFormat(item.price)}
                          </td>
                          <td>{item.count}</td>
                          <td>{item.brand}</td>
                          <td>{item.model}</td>
                          <td>{item.group}</td>
                          <td>{item.alt_group}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

ReportsCost1.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(ReportsCost1)
